import { common as enCommon } from './en/common';
import { registration as enRegistration } from './en/registration';
import { regulations as enRegulations } from './en/regulations';
import { common as hrCommon } from './hr/common';
import { registration as hrRegistration } from './hr/registration';
import { regulations as hrRegulations } from './hr/regulations';

const resources = {
  en: {
    common: enCommon,
    registration: enRegistration,
    regulations: enRegulations,
  },
  hr: {
    common: hrCommon,
    registration: hrRegistration,
    regulations: hrRegulations,
  },
};

export default resources;